import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#DE9A2D',
        anchor: '#DE9A2D',
        black: '#2c3e50',
        stroke: {
          base: '#E4E4E7',
          lighten1: '#ECECEE'
        },
      }
    }
  }
})
